import React, {memo, useCallback} from 'react';
import {PasswordContainer} from '../../../components/PasswordContainer';
import {SettingsPageContainer} from '../../../components/Settings/SettingsPageContainer';
import {DEVELOPER_URL} from '../index';
import {onClickHandler} from '../../../utils/onclick';
import {useRPC} from '../../../hooks/rpc';
import {useMessage} from '../../../hooks/message';

import './index.scss';

export const TestScreen = memo(function TestScreen() {
    const [rpc] = useRPC();
    const {success, failure} = useMessage();

    const click = useCallback(() => {
        rpc.test()
            .then(() => {
                success('');
            })
            .catch(failure);
    }, [
        rpc,
        failure,
        success,
    ]);

    return (
        <PasswordContainer requiredRole='service' isFullscreen={true}>
            <SettingsPageContainer
                className='service-edit'
                buttons={[]}
                backUrl={DEVELOPER_URL}>
                <div className='content-divider'>
                    <div className='content-wrapper'>
                        <div className='test-button-container' {...onClickHandler(click)}>
                            <span className='button'>CLICK ME!</span>
                        </div>
                    </div>
                    <div className='content-wrapper'>

                    </div>
                </div>
            </SettingsPageContainer>
        </PasswordContainer>
    );
});
